import { render, staticRenderFns } from "./multilangEditor.vue?vue&type=template&id=7d058164&scoped=true&"
import script from "./multilangEditor.vue?vue&type=script&lang=js&"
export * from "./multilangEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d058164",
  null
  
)

export default component.exports